{
  "name": "@myparcel-frontend/backoffice",
  "version": "2.633.0",
  "private": true,
  "type": "module",
  "scripts": {
    "build": "vite build",
    "dev": "vite --mode=dev",
    "lint": "eslint",
    "lint:fix": "eslint --fix",
    "preview": "vite preview --port 5050 --base /",
    "story:dev": "storybook dev -p 9003",
    "story:build": "storybook build",
    "test:unit": "TZ=UTC vitest run",
    "test:unit:coverage": "TZ=UTC vitest run --coverage",
    "test:unit:coverage:update": "TZ=UTC vitest run --coverage.thresholds.autoUpdate=true --coverage.enabled=true",
    "test:unit:watch": "TZ=UTC vitest --watch",
    "test:unit:watch:ui": "TZ=UTC vitest watch --ui",
    "test:bench": "TZ=UTC vitest bench",
    "typecheck": "vue-tsc --noEmit --composite false --declarationMap false"
  },
  "dependencies": {
    "@auth0/auth0-vue": "^1.0.3",
    "@faker-js/faker": "catalog:",
    "@floating-ui/dom": "catalog:",
    "@floating-ui/vue": "catalog:",
    "@gtm-support/vue-gtm": "catalog:",
    "@luzmo/vue-embed": "catalog:",
    "@mypadev/openfeature-providers-library": "catalog:openfeature",
    "@mypadev/scanner": "workspace:^",
    "@myparcel-frontend/address": "workspace:^",
    "@myparcel-frontend/address-service": "workspace:^",
    "@myparcel-frontend/bol-ecommerce-service": "workspace:^",
    "@myparcel-frontend/composables": "workspace:^",
    "@myparcel-frontend/core-api-service": "workspace:^",
    "@myparcel-frontend/cscart-ecommerce-service": "workspace:^",
    "@myparcel-frontend/csv-import": "workspace:^",
    "@myparcel-frontend/delegation-service": "workspace:^",
    "@myparcel-frontend/event-service": "workspace:^",
    "@myparcel-frontend/forms": "workspace:^",
    "@myparcel-frontend/generic-ecommerce-service": "workspace:^",
    "@myparcel-frontend/i18n": "workspace:^",
    "@myparcel-frontend/iam-service": "workspace:^",
    "@myparcel-frontend/icons": "workspace:^",
    "@myparcel-frontend/lightspeed-ecommerce-service": "workspace:^",
    "@myparcel-frontend/notifications": "workspace:^",
    "@myparcel-frontend/order-service": "workspace:^",
    "@myparcel-frontend/orders": "workspace:^",
    "@myparcel-frontend/plugins": "workspace:^",
    "@myparcel-frontend/presta-ecommerce-service": "workspace:^",
    "@myparcel-frontend/printing-service": "workspace:^",
    "@myparcel-frontend/product-service": "workspace:^",
    "@myparcel-frontend/proposition": "workspace:^",
    "@myparcel-frontend/purchase-order-service": "workspace:^",
    "@myparcel-frontend/rule-expressions": "workspace:^",
    "@myparcel-frontend/rule-service": "workspace:^",
    "@myparcel-frontend/sdk": "workspace:^",
    "@myparcel-frontend/service-utils": "workspace:^",
    "@myparcel-frontend/shipments": "workspace:^",
    "@myparcel-frontend/shopify-ecommerce-service": "workspace:^",
    "@myparcel-frontend/ui": "workspace:^",
    "@myparcel-frontend/utils": "workspace:^",
    "@myparcel-frontend/woo-ecommerce-service": "workspace:^",
    "@myparcel/sdk": "catalog:",
    "@myparcel/vue-form-builder": "catalog:vue3",
    "@openfeature/core": "catalog:openfeature",
    "@openfeature/web-sdk": "catalog:openfeature",
    "@vuepic/vue-datepicker": "4.1.0",
    "@vueuse/components": "catalog:",
    "@vueuse/core": "catalog:",
    "@vueuse/router": "catalog:",
    "dompurify": "catalog:",
    "es-toolkit": "catalog:",
    "lowdb": "catalog:",
    "mathjs": "catalog:",
    "msw": "catalog:",
    "pinia": "catalog:vue3",
    "unpdf": "1.6.2",
    "vee-validate": "catalog:",
    "vfb-legacy": "npm:@myparcel/vue-form-builder@1.0.0-beta.23",
    "vue": "catalog:vue3",
    "vue-i18n": "catalog:vue3",
    "vue-router": "catalog:vue3",
    "zod": "catalog:"
  },
  "devDependencies": {
    "@myparcel-frontend/eslint-config": "workspace:*",
    "@myparcel-frontend/tailwind-preset": "workspace:^",
    "@myparcel-frontend/testing": "workspace:*",
    "@myparcel-frontend/types": "workspace:*",
    "@pinia/testing": "catalog:vue3",
    "@storybook/addon-a11y": "catalog:storybook",
    "@storybook/addon-designs": "catalog:storybook",
    "@storybook/vue3": "catalog:storybook",
    "@storybook/vue3-vite": "catalog:storybook",
    "@testing-library/jest-dom": "catalog:",
    "@testing-library/user-event": "catalog:",
    "@testing-library/vue": "catalog:",
    "@types/heremaps": "3.1.14",
    "@types/node": "catalog:",
    "@vitejs/plugin-vue": "catalog:",
    "@vitest/coverage-istanbul": "catalog:vitest",
    "@vitest/coverage-v8": "catalog:vitest",
    "@vitest/ui": "catalog:vitest",
    "@vue/test-utils": "2.4.11",
    "happy-dom": "catalog:",
    "msw-storybook-addon": "catalog:storybook",
    "postcss": "catalog:",
    "rollup-plugin-visualizer": "catalog:",
    "storybook": "catalog:storybook",
    "storybook-vue3-router": "catalog:storybook",
    "tailwindcss": "catalog:",
    "typescript": "catalog:",
    "vite": "catalog:",
    "vitest": "catalog:vitest",
    "vue-tsc": "catalog:vue3"
  },
  "engines": {
    "npm": ">=10.9.4",
    "node": ">=22.22.0"
  },
  "packageManager": "pnpm@11.20.0",
  "msw": {
    "workerDirectory": [
      "public"
    ]
  }
}
